import { Warning } from '@phosphor-icons/react';
import { t } from 'i18next';

import { FlexBox, Tooltip } from 'core/elements';
import { Color } from 'theme/enums';

export const CostExceedsTooltip = () => {
  return (
    <Tooltip title={t('messagePurchaseCostExceedsStandardCostTooltip')} color={Color.WARNING}>
      <FlexBox sx={{ color: 'custom.warning.main', fontSize: 16 }}>
        <Warning />
      </FlexBox>
    </Tooltip>
  );
};
